import { makeHublessEarlyRequest } from './hubless-early-requester/hublessEarlyRequestor';
import { makeIpLocationEarlyRequest } from './iplocation-early-requester/iplocationEarlyRequester';
makeHublessEarlyRequest();
makeIpLocationEarlyRequest();